import { useEffect, useRef, type RefObject } from 'react';

/**
 * Returns a ref to attach to the messages container. When firstUnreadMessageId
 * is set, scrolls to that message on initial load (once per mount).
 */
export function useScrollToFirstUnread(
  firstUnreadMessageId: string | null | undefined
): RefObject<HTMLDivElement> {
  const contentRef = useRef<HTMLDivElement>(null);
  const hasScrolledToUnreadRef = useRef(false);

  useEffect(() => {
    if (
      firstUnreadMessageId === undefined ||
      firstUnreadMessageId === null ||
      hasScrolledToUnreadRef.current
    ) {
      return;
    }
    hasScrolledToUnreadRef.current = true;
    const scrollToFirstUnread = () => {
      const el = contentRef.current?.querySelector(
        `[data-message-id="${firstUnreadMessageId}"]`
      );
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };
    requestAnimationFrame(() => {
      requestAnimationFrame(scrollToFirstUnread);
    });
  }, [firstUnreadMessageId]);

  return contentRef;
}
